import {documentToReactComponents} from '@contentful/rich-text-react-renderer'
import {BLOCKS, MARKS} from '@contentful/rich-text-types'
import {Box, SectionIntro} from '@primer/react-brand'

import {Section} from '../../../../../brand/components/BrandPage'
import type {GenericContent, GenericGroup, GenericSectionWithIds} from '../../../../../brand/lib/types/contentful'

import {FeaturesRiver} from './FeaturesRiver'
import {FeaturesRiverBreakout} from './FeaturesRiverBreakout'

import styles from './FeaturesSection.module.css'

type Props = {
  contentfulContent: GenericSectionWithIds
}

export function FeaturesSection(props: Props) {
  const {contentfulContent} = props
  const {sectionIntro} = contentfulContent.fields
  const {featuresCopilotFeaturesRiverBreakout, featuresCopilotFeaturesRivers} = contentfulContent.ids as {
    featuresCopilotFeaturesRiverBreakout: GenericContent
    featuresCopilotFeaturesRivers: GenericGroup
  }

  return (
    <Section id="features">
      {sectionIntro ? (
        <SectionIntro fullWidth align="center" className="lp-SectionIntro">
          {sectionIntro.fields.label ? (
            <SectionIntro.Label>{sectionIntro.fields.label.fields.text}</SectionIntro.Label>
          ) : null}

          <SectionIntro.Heading size="2" weight="semibold">
            {documentToReactComponents(sectionIntro.fields.heading, {
              renderMark: {
                [MARKS.BOLD]: text => <em>{text}</em>,
              },
              renderNode: {
                [BLOCKS.PARAGRAPH]: (_, children) => [children, <br key="line-break" />],
              },
            })}
          </SectionIntro.Heading>
        </SectionIntro>
      ) : null}

      {featuresCopilotFeaturesRiverBreakout ? (
        <FeaturesRiverBreakout riverBreakout={featuresCopilotFeaturesRiverBreakout} />
      ) : null}

      <Box paddingBlockStart={48} aria-hidden />

      {featuresCopilotFeaturesRivers && featuresCopilotFeaturesRivers.fields.content ? (
        <div className={styles.rivers}>
          {(featuresCopilotFeaturesRivers.fields.content as GenericContent[]).map(riverItem => (
            <FeaturesRiver key={riverItem.sys.id} river={riverItem} />
          ))}
        </div>
      ) : null}
    </Section>
  )
}

try{ FeaturesSection.displayName ||= 'FeaturesSection' } catch {}